/* Footer (§9): store clock in the store's time zone, back to top, and the curtain footer. */
class SiteFooter extends HTMLElement {
  connectedCallback() {
    this.inner = this.querySelector('[data-footer-inner]');
    this.startClock();

    this.topLink = this.querySelector('[data-back-to-top]');
    this.onTop = (event) => {
      event.preventDefault();
      if (window.Theme.smoothScroll) window.Theme.smoothScroll.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: window.Theme.motionAllowed() ? 'smooth' : 'auto' });
      const main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    };
    if (this.topLink) this.topLink.addEventListener('click', this.onTop);

    if (this.classList.contains('ft--curtain')) {
      this.onResize = () => this.syncCurtain();
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.inner);
      window.addEventListener('resize', this.onResize, { passive: true });
    }
  }

  disconnectedCallback() {
    clearTimeout(this.tick);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.onResize) window.removeEventListener('resize', this.onResize);
  }

  startClock() {
    const clock = this.querySelector('[data-clock]');
    if (!clock) return;
    let format;
    try {
      format = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
        timeZone: clock.dataset.timezone || undefined,
      });
    } catch (error) {
      return; // Unknown time zone: leave the clock hidden.
    }
    const time = clock.querySelector('[data-clock-time]');
    const update = () => {
      const now = new Date();
      time.textContent = format.format(now);
      this.tick = setTimeout(update, 60000 - (now.getSeconds() * 1000 + now.getMilliseconds()));
    };
    update();
    clock.hidden = false;
  }

  // Only uncover when motion is allowed, the screen is at least 700px wide and the whole footer fits.
  syncCurtain() {
    const height = this.inner.offsetHeight;
    const enabled = window.Theme.motionAllowed() && window.innerWidth >= 700 && height <= window.innerHeight;
    this.style.setProperty('--footer-h', `${height}px`);
    this.classList.toggle('is-curtain', enabled);
  }
}

if (!customElements.get('site-footer')) customElements.define('site-footer', SiteFooter);
